module.exports = __webpack_public_path__ + "img/9_r.f481db66.jpg";